export const init = () => {
    const $ = jQuery;

    $( '.btn-navbar' ).on( 'click', function( e ) {
        $( '.navbar' ).toggleClass( 'active' );
    } );
};
